import { render, staticRenderFns } from "./TripSettings.vue?vue&type=template&id=e4fa1f74"
import script from "./TripSettings.vue?vue&type=script&lang=js"
export * from "./TripSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports